var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`switcher switcher_${_vm.locale}`,on:{"click":function($event){return _vm.setLocale(_vm.locale === 'ru' ? 'en' : 'ru')}}},_vm._l((_vm.locales),function(l){return _c('span',{key:l.code,class:['switcher__btn', { active: _vm.locale === l.code }]},[_vm._v(" "+_vm._s(l.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }